module.exports = __webpack_public_path__ + "static/media/2.2c2d4d63.png";